import { CommandResult } from '../amorg-common'
import { Survey } from '../amorg-common'
import { SurveyAnswerStatus } from '../amorg-common'
import { SurveySegment } from '../amorg-common'
import { queryAuthWrapper, commandAuthWrapper } from "./serverApiHelpers";
import { surveysPath } from "./surveyClientApi";

export async function getSurveyAsAnonymous(siteId: string, surveyId: string): Promise<Survey>
{
    const result = await queryAuthWrapper(`${surveysPath}/${siteId}.${surveyId}`);
    return result === null
        ? null
        : { ...result, start: new Date(result.start), end: new Date(result.end) };
}

export const startAnswer = async (siteId: string, surveyId: string, email: string): Promise<CommandResult> =>
    (await commandAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers`, 'POST', { email }));

export const getAnswerStatus = async (siteId: string, surveyId: string, answerId: string): Promise<SurveyAnswerStatus> =>
    (await queryAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers/${answerId}`));

export const submitSegments = async (siteId: string, surveyId: string, answerId: string, segments: SurveySegment[]): Promise<CommandResult> =>
    (await commandAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers/${answerId}/segments`, 'POST', { segments }));

// submitting undefined as comment will leave a possible existing comment value
export const submitSelection = async (siteId: string, surveyId: string, answerId: string, questionIndex: number, value: number, comment?: string): Promise<CommandResult> =>
    (await commandAuthWrapper(`${surveysPath}/${siteId}.${surveyId}/answers/${answerId}/selection`, 'POST', { questionIndex, value, comment }));
